/**
 * This only implements the parts that is needed in Hypothesis
 *    1) "documentload" event
 *
 *    2) {
 *         documentInfo,
 *         downloadComplete,
 *         pdfDocument,
 *         pdfViewer,
 *         url,
 *       }
 *
 *   For issue:
 *    https://github.com/hypothesis/product-backlog/issues/916
 *
 *   For details:
 *      https://github.com/hypothesis/client/blob/master/src/annotator/plugin/test/pdf-metadata-test.js
 *      https://github.com/hypothesis/client/blob/master/src/annotator/plugin/pdf-metadata.js
 *      https://github.com/hypothesis/client/tree/master/src/annotator/anchoring
 */
export async function createContract(pdfDocument, pdfViewer) {
  const metadata = await pdfDocument.getMetadata();
  const title = (metadata && metadata.info && metadata.info.Title) ? metadata.info.Title : '';

  return {
    documentInfo: { Title: title },
    downloadComplete: true,
    pdfDocument,
    pdfViewer,
    url: document.location.href,
  };
}

export function notifyDocumentLoaded(pdfViewer) {
  pdfViewer.eventBus.dispatch('documentloaded');
}
